import rootReducer from "./reducers";
import { createStore, applyMiddleware, compose } from "redux";
import { apiMiddleware } from "react-redux-api-tools";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

const composeEnhancers =
  process.env.NODE_ENV === "production" ? compose : composeWithDevTools;
const enhancers = [applyMiddleware(thunk, apiMiddleware)];

const store = createStore(rootReducer, composeEnhancers(...enhancers));

export default store;
